import MicroModal from 'micromodal';
import axios from "axios";
import { delay } from '../helpers/utils/delay';

class Modal {
    constructor(document) {
        this.root = document;
        this.triggers = [];
        this.html = null;

        MicroModal.init();
        this.getElements();

        if (this.canInit()) {
            this.addEvents();
        }
    }

    getElements() {
        this.triggers = this.root.querySelectorAll('.js-modal-trigger');
    }

    canInit() {
        return this.triggers.length > 0;
    }

    addEvents() {
        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                this.getContent(trigger).then(() => {
                    this.showModal(trigger);
                });
            });
        });
    }

    async getContent(trigger) {
        return axios.get(`/xhr/artist/details.php?id=${trigger.dataset.artist}`)
            .then((response) => {
                if (response.data.success) {
                    this.html = response.data.html;
                }
            })
            .catch(console.log);
    }

    showModal(trigger) {
        const modalBody = document.querySelector('.modal-content');
        modalBody.innerHTML = this.html;

        MicroModal.show(trigger.dataset.micromodal, {
            onShow: (modal) => {
                document.body.classList.add('modal-open');
                delay(1).then(() => {
                    modal.classList.add('is-visible');
                });
            },
            onClose: (modal) => {
                modal.classList.remove('is-visible');
                document.body.classList.remove('modal-open');
            },
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            debugMode: true,
        });
    }
}

new Modal(document); // eslint-disable-line no-new